<template>
  <div
    :am-mode="isActive ? 'edit' : 'show'"
    am-attr-item
    @click="editMode()"
    v-click-outside="showMode"
    @keyup.esc="showMode"
    tabindex="1"
  >
    <div
      :am-edit="isActive ? '' : null"
      :am-show="isActive ? null : ''"
      :style="isOpenTop ? 'bottom: -4px; top: auto;' : null"
      ref="attr"
    >
      <div class="_display:flex _flex-wrap:wrap _align-items:center">
        <i-badge
          color="primary"
          v-for="(attr, index) in data.data"
          :key="index"
          :am-tag-badge="attr.id % 10"
          class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
          :title="attr.name"
        >
          <p>{{ attr.name }}</p>
          <div v-if="isActive" class="_display:flex _align-items:center">
            <svg am-icon @click="delAttr(index)" viewBox="0 0 24 24" style="fill: var(----color);">
              <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
            </svg>
          </div>
        </i-badge>
        <svg
          v-if="isActive"
          viewBox="0 0 24 24"
          class="_margin-left:1/4"
          am-icon="color"
          :am-loading="loading"
          @click="showAttr()"
        >
          <use v-if="!loading" xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24" />
          <use v-else xlink:href="@/assets/icons.svg#preloader" x="0" y="0" width="24" height="24" />
          <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
        </svg>
      </div>
      <div v-if="isActive && showAddAttributes && !isLoad" am-add-attr ref="addAttr">
        <hr>
        <i-input
          v-model="inputSearch"
          placeholder="Search"
        />
        <div
          v-if="resultAddOption"
          am-result-option
          class="_margin:1/4 _padding:1/4 _background:warning"
        >
          {{ resultAddOption }}
        </div>
        <div
          v-if="filterAttr && filterAttr.length > 0"
          am-scroll
          class="_margin-top:1/2 _margin-bottom:1/2 _display:flex _flex-wrap:wrap _align-items:center"
        >
          <i-badge
            v-for="attr in filterAttr"
            :key="attr.id"
            am-tag-badge
            class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
            :title="attr.name"
            @click="addAttr(attr)"
          >
            <p>{{ attr.name }}</p>
            <svg
              viewBox="0 0 24 24"
              am-icon="color"
            >
              <use xlink:href="@/assets/icons.svg#plus2" x="0" y="0" width="24" height="24" />
            </svg>
          </i-badge>
        </div>
        <div v-else-if="searchValue" class="_margin:1/2">
          Add option:
          <i-badge
            am-tag-badge
            class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
            @click="addOptions(searchValue)"
          >
            <p>{{ searchValue }}</p>
          </i-badge>
        </div>
        <div v-else class="_margin:1/2">
          No results
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'AttrItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showAddAttributes: false,
    isActive: false,
    isOpenTop: false,
    resultAddOption: null
  }),
  computed: {
    ...mapGetters('attributes', [
      'getFilterAttributes',
      'isLoad'
    ]),
    ...mapState('attributes', ['searchValue', 'loading']),
    inputSearch: {
      get () {
        return this.searchValue
      },
      set (val) {
        this.resultAddOption = null
        this.changeSettingsSearch(val)
      }
    },
    filterAttr () {
      if (this.getFilterAttributes) {
        return this.getFilterAttributes.filter((elem) => !this.data.data.find(({ id }) => elem.id === id))
      } else return null
    },
    value () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    ...mapMutations('attributes', [
      'setChangedType',
      'changeSettingsSearch'
    ]),
    ...mapActions('attributes', ['getAttributes', 'addOption']),
    async addOptions (option) {
      this.resultAddOption = await this.addOption(option)
    },
    delAttr (index) {
      this.value.splice(index, 1)
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    addAttr (attr) {
      if (this.data.singular) this.value.splice(0, this.value.length)
      this.value.push(attr)
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    async showAttr () {
      await this.getAttributes()
      this.showAddAttributes = true
    },
    editMode () {
      if (this.$refs.attr.getBoundingClientRect().y / window.innerHeight * 100 > 50) {
        this.isOpenTop = true
      }
      this.isActive = true
      this.$emit('editing', this.data.index)
      this.setChangedType(this.data.type)
      this.changeSettingsSearch(null)
    },
    showMode () {
      this.isOpenTop = false
      this.isActive = false
      this.showAddAttributes = false
    }
  }
}
</script>

<style lang="scss">
[am-attr-item] {
  [am-loading~="true"] {
    animation: rotate 300ms ease-in-out infinite;
  }
  [am-edit] {
    [am-add-attr] [am-scroll] {
      max-height: 20rem;
      overflow-y: scroll;
      [am-tag-badge],
      [am-tag-badge] p {
        cursor: pointer;
      }
    }
  }
}
[am-result-option] {
  border-radius: 5px;
}
@keyframes rotate {
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
}
</style>
